export const Skills = () => {
  return (
    <div id='skills' className='row'>
      <div className='col-12 text-center'>
        <h1 className='section-title'>Skills</h1>
      </div>
      <div className='col-1'></div>
      <div className='col-10 mt-5'>
        <div className='row text-center fs-5'>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img className='m-2 img-fluid' src='images/html.png' alt='' />
              <div>HTML5</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img className='m-2 img-fluid' src='images/css.png' alt='' />
              <div>CSS3</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img className='m-2 img-fluid' src='images/sass.png' alt='' />
              <div>Sass</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/bootstrap.png'
                alt=''
              />
              <div>Bootstrap</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/tailwindcss.png'
                alt=''
              />
              <div>Tailwind CSS</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/materialui.png'
                alt=''
              />
              <div>Material UI</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img className='m-2 img-fluid' src='images/js.png' alt='' />
              <div>JavaScript</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/jquery.png'
                alt=''
              />
              <div>JQuery</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/typescript.png'
                alt=''
              />
              <div>TypeScript</div>
            </div>
          </div>


          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/angular.png'
                alt=''
              />
              <div>Angular</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/react.png'
                alt=''
              />
              <div>ReactJs</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/nextjs.png'
                alt=''
              />
              <div>NextJs</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/express.png'
                alt=''
              />
              <div>ExpressJs</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/mongodb.png'
                alt=''
              />
              <div>MongoDB</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/nodejs.png'
                alt=''
              />
              <div>NodeJs</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/graphql.png'
                alt=''
              />
              <div>GraphQl</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/git.png'
                alt=''
              />
              <div>Git</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/github.png'
                alt=''
              />
              <div>Github</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/gitlab.png'
                alt=''
              />
              <div>Gitlab</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/firebase.png'
                alt=''
              />
              <div>Firebase</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/netlify.png'
                alt=''
              />
              <div>Netlify</div>
            </div>
          </div>
          <div className='col-lg-2 col-6 p-2 mt-3 mb-5'>
            <div
              data-wow-duration='0.5s'
              data-wow-offset='70'
              className='wow animate__fadeInUp m-1 rounded-3  bg-white p-2 icons hvr-float'
            >
              <img
                className='m-2 img-fluid'
                src='images/heroku.png'
                alt=''
              />
              <div>Heroku</div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-1'></div>
    </div>
  )
}
